import { ContainerComponent, wrap } from 'AppReact';
import React from 'react';
import { RelativeWrapper } from 'wrappers';
import { DownCaretSvg, LeftArrowSvg, RightArrowSvg } from 'components/icons';
import { NoWrap, Text } from 'atoms';
import Controller from './controller';
import internalState from './internalState';
import {
  DropdownBodyWrapper,
  DropdownHeaderWrapper,
  FlexWrapper,
  FooterWrapper
} from './wrappers';
import { DropdownCaret, NavigationButton, PageCount, PageNumber } from './atoms';
import getIsMobile from 'components/atoms/utils/getIsMobile';

const isMobile = getIsMobile();

const dropdownRef = React.createRef();

export const definition = {
  name: 'TableFooter',
  controller: Controller,
  initialProps: ({ pageNumber, pageSize, total }) => ({ pageNumber, pageSize, total }),
  renderIf: ({ total }) => !(total == undefined || total == 0),
  props: internalState,
  elements: [
    {
      wrapper: FlexWrapper,
      name: 'Navigator',
      elements: [
        {
          component: NavigationButton,
          name: 'FirstPage',
          displayValue: () => LeftArrowSvg({ double: true }),
          displayState: ({ pageNumber ,total ,pageSize }) => {
            const isHidden = pageNumber === 0
            return { hidden: isHidden}
          }, 
          bindings: (state) => state
        },
        {
          component: NavigationButton,
          name: 'PrevPage',
          displayValue: () => LeftArrowSvg({}),
          displayState: ({ pageNumber ,total ,pageSize }) => {
            const isHidden = pageNumber === 0
            return { hidden: isHidden }
          },
          bindings: (state) => state
        },
        {
          component: PageNumber,
          isListOf: { option: [-2, -1, 0, 1, 2] },
          name: 'PageNumber',
          displayValue: ({ pageNumber, option }) => pageNumber + option + 1,
          displayState: ({ option, pageNumber, pageSize, total }) => {
            const pagesCount = Math.ceil(total / pageSize);
            const isHidden = (pageNumber + option < 0) || (pageNumber + option >= pagesCount);
            return { selected: option === 0, hidden: isHidden };
          },
          bindings: (state) => state
        },
        {
          component: NavigationButton,
          name: 'NextPage',
          displayValue: () => RightArrowSvg({}),
          displayState: ({ pageNumber ,total ,pageSize }) => {
            const isHidden = pageNumber+1 == Math.ceil(total / pageSize);
            return { hidden: isHidden }
          },
          bindings: (state) => state
        },
        {
          component: NavigationButton,
          name: 'LastPage',
          displayValue: () => RightArrowSvg({ double: true }),
          displayState: ({ pageNumber ,total ,pageSize }) => {
            const isHidden = pageNumber+1 === Math.ceil(total / pageSize);
            return { hidden: isHidden };
          },
          bindings: (state) => state
        }
      ]
    },
    {
      wrapper: FlexWrapper,
      name: 'PageSizeSelector',
      elements: [
        {
          component: Text,
          name: 'View',
          displayValue: () => 'View'
        },
        {
          wrapper: RelativeWrapper,
          name: 'Dropdown',
          elements: [
            {
              wrapper: DropdownHeaderWrapper,
              name: 'Header',
              isButton: true,
              bindings: ({ isDropdownOpen }) => ({ isDropdownOpen, dropdownRef }),
              elements: [
                {
                  component: Text,
                  bindings: () => ({}),
                  displayValue: ({ pageSize }) => (pageSize === 99999 ? 'All' : pageSize.toString())
                },
                {
                  component: DropdownCaret,
                  name: 'Caret',
                  displayValue: () => DownCaretSvg({}),
                  bindings: () => ({})
                }
              ]
            },
            {
              wrapper: DropdownBodyWrapper,
              name: 'Body',
              ref: dropdownRef,
              renderIf: ({ isDropdownOpen }) => isDropdownOpen,
              elements: [
                {
                  component: PageCount,
                  name: 'PageSize',
                  isListOf: { option: [10, 15, 30, 45, 99999] },
                  bindings: ({ option }) => ({ option }),
                  displayValue: ({ option }) => (option === 99999 ? 'All' : option.toString()),
                  displayState: ({ option, pageSize }) => ({ selected: option === pageSize })
                }
              ]
            }
          ]
        },
        {
          component: NoWrap,
          name: 'Items',
          renderIf: ({ }) => !isMobile,
          displayValue: () => 'items per page',
          bindings: () => ({})
        }
      ]
    },
    {
      component: Text,
      name: 'TotalCount',
      renderIf: ({ }) => !isMobile,
      displayValue: ({ total, pageNumber, pageSize }) => {
        const upperLimit = Math.min(total, (pageNumber + 1) * pageSize);
        return `${pageNumber * pageSize + 1} - ${upperLimit} out of ${total} items`;
      },
      bindings: () => ({})
    }
  ]
};

const TabsFilter = wrap(ContainerComponent(definition), FooterWrapper);
export default TabsFilter;
